import script from "./viemaoFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./viemaoFooter.vue?vue&type=script&setup=true&lang=js"

import "./viemaoFooter.vue?vue&type=style&index=0&id=66d93139&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d93139"]])

export default __exports__